import { render, staticRenderFns } from "./InspirationTeaser.vue?vue&type=template&id=49dfaa1c"
import script from "./InspirationTeaser.vue?vue&type=script&lang=js"
export * from "./InspirationTeaser.vue?vue&type=script&lang=js"
import style0 from "./InspirationTeaser.vue?vue&type=style&index=0&id=49dfaa1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports